import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const SellerLoginApi = createAsyncThunk(
  "sellerloginData/SellerloginApi",
  async (email, thunkAPI) => {
    try {
      const response = await axios.post(endPoint.SellerLoginApi, {
        email: email?.email,
        password: email?.password,
      });
  
      localStorage.setItem("SellerloginData", response?.data?.seller?.id);
      localStorage.setItem("SellerTokenData", response?.data?.token);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const SellerLoginSlice = createSlice({
  name: "SellerLogin",
  initialState: {
    SellerLogin: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SellerLoginApi.fulfilled, (state, action) => {
        state.SellerLogin = action.payload;
      })
      .addCase(SellerLoginApi.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default SellerLoginSlice.reducer;
